import { useCallback } from 'react';
import type {
	ChildResult,
	CommandSections,
} from '@atlassian/jira-command-palette/src/common/types/commands/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { useGetQuickSearchBoardCommands } from '../../../../../common/ui/board/index.tsx';
import { QUICK_SEARCH_PRIORITY } from '../../../../../common/ui/constants.tsx';
import type {
	GetQuickSearchChildResultProps,
	UseGetChildResult,
} from '../../../../../common/ui/types.tsx';
import { SECTION_ID } from './constants.tsx';
import { messages } from './messages.tsx';

export const useGetSearchBoardsChildResult: UseGetChildResult = () => {
	const { formatMessage } = useIntl();

	const { getQuickSearchBoardCommands } = useGetQuickSearchBoardCommands({
		section: SECTION_ID,
		showViewAll: true,
	});
	const getChildResult = useCallback(
		(props: GetQuickSearchChildResultProps): ChildResult => {
			const sections: CommandSections = {
				[SECTION_ID]: {
					id: SECTION_ID,
					name: formatMessage(messages.boards),
					priority: QUICK_SEARCH_PRIORITY.BOARDS,
				},
			};

			const commands = getQuickSearchBoardCommands(props);

			return {
				sections,
				commands,
			};
		},
		[formatMessage, getQuickSearchBoardCommands],
	);

	return { getChildResult };
};
